<template>
	<div class="hero-video">
		<video class="video-wrapper" muted autoplay loop>
			<source :src="video" type="video/mp4" />
		</video>
		<div class="text-wrapper">
			<h1>{{ settings.title }}</h1>
			<p>{{ settings.text }}</p>
			<a :href="settings.button_link">{{ settings.button_label }}</a>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		video: { required: true },
		settings: { type: Object, required: true }
	}
};
</script>

<style lang="scss" scoped>
.hero-video {
	overflow: hidden;
	position: relative;
	height: 100%;

	&::before {
		content: "";
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		z-index: 10;
		background-color: rgba(0, 0, 0, 0.2);
	}

	video {
		width: auto;
	}

	.text-wrapper {
		height: 100%;
		max-width: 580px;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: $white;
		padding: 0 20px;
		z-index: 11;

		h1 {
			font-size: 50px;
			font-weight: 400;
			letter-spacing: 3.33px;
			line-height: 60px;
			text-transform: uppercase;

			@include res(tab-p) {
				font-size: 35px;
				line-height: 40px;
				letter-spacing: 1px;
			}
		}

		p {
			font-size: 14px;
			font-weight: 400;
			line-height: 20px;
			margin: 10px 0 25px;

			@include res(tab-p) {
				font-size: 16px;
				margin: 10px 0 15px;
			}
		}

		a {
			@include button(#ffffff, 15px, 55px);
			border: 1px solid $white;
			text-transform: uppercase;
			align-self: center;

			@include res(tab-p) {
				width: 100%;
				@include button(#ffffff, 10px, 55px);
			}
		}
	}
}
</style>
